module.exports = __webpack_public_path__ + "img/popup_emergency.8e9ca46c.svg";